import { Route } from 'react-router-dom';
import { LayoutContainer } from 'components/layout';
import LoginPage from '../pages/login';

const LoginRouter = (
  <Route
    path="login"
    element={
      <LayoutContainer title="Login">
        <LoginPage />
      </LayoutContainer>
    }
  />
);
export default LoginRouter;